import { authRequest } from './index.js'

export async function update_report(formData, package_type){
  let data
  await authRequest.post(
    '/option/report',
    {report: {options: formData.options,characters: formData.characters, package_type}},
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

function packagesParser(responseData){
  const parsedData = responseData.data.map(item => {
    const packageType = item.attributes.name;
    const id = item.id;
    const options = {};
  
    // Find the related option_meta data for the current item
    const optionMetaData = item.relationships.option_meta.data.map(option => {
      const optionDetails = responseData.included.find(includedItem => includedItem.id === option.id);
  
      if (optionDetails) {
        options[optionDetails.attributes.key] = {id: optionDetails.id, value: optionDetails.attributes.value};
      }
  
      return optionDetails;
    });
  
    return { id, package_type: packageType, options };
  }); 
  return parsedData;
}

export async function get_packages(){
  let data
  await authRequest.get(
    '/packages',
  )
  .then(function(result){
    let parser = packagesParser(result.data)
    data = {result: parser, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

function packageParser(responseData){
  const item = responseData.data.data
  const packageType = item.attributes.name;
  const id = item.id;
  const options = {};

  // Find the related option_meta data for the current item
  const optionMetaData = item.relationships.option_meta.data.map(option => {
    const optionDetails = responseData.data.included.find(includedItem => includedItem.id === option.id);

    if (optionDetails) {
      options[optionDetails.attributes.key] = {id: optionDetails.id, value: optionDetails.attributes.value};
    }

    return optionDetails;
  });

  return { id, package_type: packageType, options };
  // const parsedData = responseData.data.map(item => {
  // }); 
  // return parsedData;
}

export async function get_package(package_id){
  let data
  await authRequest.get(
    '/packages/' + package_id,
  )
  .then(function(result){
    let parsedData = packageParser(result)
    data = {result: parsedData, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_characteristics(package_id){
  let data
  await authRequest.get(
    'packages/' + package_id + '/characteristics/',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_package(id, option_meta){
  let data
  const option_meta_arr = Object.entries(option_meta)
    .filter(([key, item]) => item && item.id && item.value)
    .map(([key, item]) => ({ id: item.id, key, value: item.value }));
  
  console.log("🚀 ~ file: option.js:78 ~ update_package ~ data:", option_meta_arr)
  await authRequest.post(
    '/packages/' + id,
    { package: {
        option_meta_attributes: option_meta_arr
      }
    },
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_traits(id, characters){
  let data
  characters['traits_attributes'] = characters.traits
  // delete characters['traits']
  await authRequest.patch(
    '/characteristics/' + id,
    { characteristic: characters
    },
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_option(id, option){
  let data
  await authRequest.patch(
    '/options/' + id,
    { option },
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function create_option(option){
  let data
  await authRequest.post(
    '/options',
    { option },
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_option(name){
  let data
  await authRequest.get(
    '/options/' + name,
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function parsePackageswithCharacteristics(packages){
  const updatedPackages = await Promise.all(packages.map(async (item) => {
    const response = await get_characteristics(item.id)
    let parsedChar = parserCharacteristic(response.result)
    item['characters'] = parsedChar
    return item
  }))
  return updatedPackages
}

export async function parsePackagewithCharacteristics(packageObj){
  const response = await get_characteristics(packageObj.id)
  let parsedChar = parserCharacteristic(response.result)
  packageObj['characters'] = parsedChar
  return packageObj
}

export async function get_trait(trait_id){
  let data
  await authRequest.get(
    'traits/' + trait_id,
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

function parserCharacteristic(responseData){
  const parsedData = responseData.data.map(item => {
    const name = item.attributes.name;
    const id = item.id;
    const traits = [];
  
    // Find the related option_meta data for the current item
    const optionMetaData = item.relationships.traits.data.map(trait => {
      const traitDetails = responseData.included.find(includedItem => includedItem.id === trait.id);
  
      if (traitDetails) {
        let temp = {}
        temp['name'] = traitDetails.attributes.name
        temp['id'] = traitDetails.id
        traits.push(temp)
      }
  
      return traitDetails;
    });
  
    return { id, name, traits };
  });
  return parsedData
}

export async function get_count(type = 'user'){
  let data
  await authRequest.get(
    `${type}_count`,
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}